import { render } from "./Pokedex.vue?vue&type=template&id=229d6ba4&scoped=true"
import script from "./Pokedex.vue?vue&type=script&lang=js"
export * from "./Pokedex.vue?vue&type=script&lang=js"

import "./Pokedex.vue?vue&type=style&index=0&id=229d6ba4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Librom\\Projects\\librodex-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229d6ba4"]])

export default __exports__